import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './SchoolVideos_style'
import SectionSubTitle from 'components/SectionSubTitle/SectionSubTitle'
import isEmpty from 'lodash.isempty'
import SchoolAPI from 'api/SchoolAPI'
import HorizontalCardsSlider from 'components/HorizontalCardsSlider/HorizontalCardsSlider'
import ResponsiveVideo from 'components/ResponsiveVideo/ResponsiveVideo'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import CTAAlert from 'components/CTAAlert/CTAAlert'
import { SCHOOL_INDEX_SCHOOL_VIDEOS } from 'assets/AlertsHelper'

const SchoolVideos = (props) => {
    const { user } = props
    const classes = useStyles()
    const [videos, setVideos] = useState([])

    useEffect(() => {
        SchoolAPI.GetSchoolVideos().then((response) => {
            setVideos(response.data.videos)
        })
    }, [])

    if (isEmpty(videos)) return null

    return (
        <Box className={classes.videoMainBox}>
            <SectionSubTitle titleId='school_index.school_videos.title' descriptionId='school_index.school_videos.description'/>
            <HorizontalCardsSlider shift={500}>
                {videos.map((video, index) => {
                    return (
                        <Box key={index}>
                            <Box className={classes.videoBox}>
                                <ResponsiveVideo
                                    video={{ url: video.url, width: 250, height: 480 }}
                                />

                            </Box>
                            {video.featured_schools[0] && video.featured_schools[0].paid &&
                                <RouteMapLink
                                    showItemType='education'
                                    showItemUrl={video.featured_schools[0].slug}
                                >
                                    <Typography className={classes.title} component='span'>
                                        <FormattedMessage
                                            id='school_index.school_videos.link'
                                            values={{ school: video.featured_schools[0].name }}
                                        />
                                    </Typography>
                                </RouteMapLink>
                            }
                        </Box>
                    )
                })}
            </HorizontalCardsSlider>
            <Box className={classes.ctaBox}>
                <CTAAlert
                    type='student_job'
                    user={user}
                    componentType='banner'
                    origin={SCHOOL_INDEX_SCHOOL_VIDEOS}
                />
            </Box>
        </Box>
    )
}

export default SchoolVideos
